/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIBillRequest
 */
export interface APIBillRequest {
    /**
     * 
     * @type {string}
     * @memberof APIBillRequest
     */
    contract: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIBillRequest
     */
    editors?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof APIBillRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof APIBillRequest
     */
    amount: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIBillRequest
     */
    paid?: boolean;
}

/**
 * Check if a given object implements the APIBillRequest interface.
 */
export function instanceOfAPIBillRequest(value: object): value is APIBillRequest {
    if (!('contract' in value) || value['contract'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function APIBillRequestFromJSON(json: any): APIBillRequest {
    return APIBillRequestFromJSONTyped(json, false);
}

export function APIBillRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBillRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contract': json['contract'],
        'editors': json['editors'] == null ? undefined : json['editors'],
        'dueDate': json['due_date'] == null ? undefined : (new Date(json['due_date'])),
        'amount': json['amount'],
        'paid': json['paid'] == null ? undefined : json['paid'],
    };
}

export function APIBillRequestToJSON(value?: APIBillRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contract': value['contract'],
        'editors': value['editors'],
        'due_date': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'amount': value['amount'],
        'paid': value['paid'],
    };
}

